module.exports = __webpack_public_path__ + "img/1.b0bcfa5f.png";